// description = "结算状态（1-待结算，2-待确认，3-已确认）"
export enum EnumSettlementStatus {
  '待结算' = 1,
  '待确认' = 2,
  '已确认' = 3,
}

// description = "结算状态（1-待结算，2-待确认，3-已确认）"
export enum EnumSettlementStatus1 {
  '待结算' = 3,
  '已结算' = 6,
}

// 状态（1-待提交，2-待确认，3-已确认）
export enum EnumSettlementSaleStatus {
  '待提交' = 1,
  '待确认' = 2,
  '已确认' = 3,
}
// 采购
export enum EnumPurchaseBillStatusName {
  '未收票' = 1,
  '已收票' = 2,
}
// 销售
export enum EnumSaleBillStatusName {
  '未开票' = 1,
  '已开票' = 2,
}

// 销售收款状态
export enum EnumSalePaymentStatus {
  '未收款' = 1,
  '部分收款' = 2,
  '已收款' = 3,
}
// 采购付款状态
export enum EnumPurchasePaymentStatus {
  '未付款' = 1,
  '部分付款' = 2,
  '已付款' = 3,
}

//  "结算单类型（1-进项结算，2-销项结算，3-返利销项结算，4-返利进项结算）")
export enum EnumSettlementType {
  '进项结算' = 1,
  '销项结算' = 2,
  '返利销项结算' = 3,
  '返利进项结算' = 4,
}
// settlementMethod 结算方式(1-账期结算，2-实销实结，3-赊账，4-现结)
export enum EnumSettlementMethod {
  '账期结算' = 1,
  '实销实结' = 2,
  '赊账' = 3,
  '现结' = 4,
}
// {81：全电专票；82：全电普票；85：纸质专票（全电开具）；86：纸质普票（全电开具）}
// 枚举定义
export enum InvoiceType {
  '全电专票' = 81,
  '全电普票' = 82,
  '纸质专票' = 85,
  '纸质普票' = 86,
}

export enum BizType {
  '进项' = 1, // 进项
  '销项' = 2, // 销项
}
// 发票状态：暂存-1，待开票-2，开票成功-3，开票失败-4，待红冲-5，已红冲-6
export enum InvoiceStatus {
  '暂存' = 1, // 暂存
  '待开票' = 2, // 待开票
  '开票成功' = 3, // 开票成功
  '开票失败' = 4, // 开票失败
  '待红冲' = 5, // 待红冲
  '已红冲' = 6, // 已红冲
}

export enum InvoiceRedBlueType {
  '红字发票' = 1, // 红字发票
  '蓝字发票' = 2, // 蓝字发票
}

export enum InvoiceSourceType {
  'ERP' = 1,
  '供应商' = 2,
  '连锁店' = 3,
}
export enum RedInvoiceReason {
  '开票有误' = 'INVOICE_ERROR',
  '销售退回' = 'SALES_RETURN',
  '服务终止' = 'SERVICE_STOP',
  '销售折让' = 'SALES_ALLOWANCE',
}

// 1-审批中 2-审核通过 3-拒绝 4-撤销
export enum PaymentSettlementStatus {
  '审核中' = 1, // 审核中
  '审核通过' = 2, // 审核通过
  '拒绝' = 3, // 拒绝
  '撤销' = 4, // 撤销
}

// 0-未付款 1-部分付款 2-已付款 3-未收款 4-部分收款 5-已收款
export enum PaymentStatus {
  '未付款' = 0,
  '部分付款' = 1,
  '已付款' = 2,
  '未收款' = 3,
  '部分收款' = 4,
  '已收款' = 5,
}
// 显示方式
export enum MapShowType {
  'DETAIL' = 1,
  'WAREHOUSE',
  'GOOD',
}
export enum MapShowTypeName {
  '明细显示' = 1,
  '按仓汇总',
  '按品汇总',
}

// 收发类型(1-收货，2-发货)
export enum MapOutInType {
  收货 = 1,
  发货,
}
// 业务单据类型 (1-采购收货，2-采退发货，3-销售发货，4-销退收货，5-组间转移收货，6-组间转移发货，7-组内转移收货，8-组内转移发货，
// 9-盘盈收货，10-盘亏发货，11-领用发货，12-报废发货，13-调剂发货，14-调剂收货，15-报损发货，16-消耗发货)
export enum MapBusinessType {
  '采购收货' = 1,
  '采退发货',
  '销售发货',
  '销退收货',
  '组间转移收货',
  '组间转移发货',
  '组内转移收货',
  '组内转移发货',
  '盘盈收货',
  '盘亏发货',
  '领用发货',
  '报废发货',
  '调剂发货',
  '调剂收货',
  '报损发货',
  '消耗发货',
}
// 明细类型(1-期初，2-期末)
export enum MapDetailsType {
  '期初' = 1,
  '期末',
}

// 支付方式（转账-1，现金-2）
export enum MapPaymentMethodList {
  '转账' = 1,
  '现金' = 2,
}

// 单据状态1-未抵冲；2-部分抵充；3-全部抵充
export enum MapPrePaymentStatus {
  '未抵冲' = 1,
  '部分抵充' = 2,
  '已抵充' = 3,
}

// 业务类型（预收-1，预付-2）
export enum MapPrePaymentOrderType {
  '预收' = 1,
  '预付' = 2,
}

/**
 * 凭证状态枚举
 * @enum {number}
 */
// // 2-已生成凭证未记账，3-NC已入账
export enum VoucherStatus {
  /** NC已记账 */
  'NC已入账' = 3,
}

/**
 * 传NC状态枚举
 * @enum {number}
 */
export enum TransferNcStatus {
  /** 待同步 */
  '待同步' = 1,

  /** 已同步 */
  '已同步' = 2,
}

/**
 * 业务类别
 * @enum {number}
 */
export enum BusinessType {
  '折扣' = 1,
  '码洋' = 2,
  '实样' = 3,
  '进项税' = 4,
  '不含税金额' = 5,
}

//主体类型（1-学校；2-公司）
export enum MapPartyType {
  SCHOOL = 1,
  COMPANY = 2,
}
// 主体类型名称（1-学校；2-公司）
export enum MapPartyTypeName {
  SCHOOL = '学校',
  COMPANY = '公司',
}
//主体类型颜色（1-学校；2-公司）
export enum MapPartyTypeColor {
  SCHOOL = '#2980b9',
  COMPANY = '#e74c3c',
}
/**
 * 业务单据类别
 * @enum {number}
 */
export enum BusinessOrderType {
  '采购收货' = 1,
  '采退发货' = 2,
}
